import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { useLocale } from "@/contexts/LocaleContext";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";

const Privacy = () => {
  const { locale } = useLocale();
  const isPt = locale.language === "pt";

  return (
    <div className="min-h-screen bg-background">
      <Navbar />
      <main className="container mx-auto px-4 py-24">
        <Link
          to="/"
          className="inline-flex items-center gap-2 text-muted-foreground hover:text-foreground mb-8 transition-colors"
        >
          <ArrowLeft size={18} />
          {isPt ? "Voltar" : "Back"}
        </Link>

        <div className="max-w-3xl mx-auto">
          <h1 className="text-4xl font-bold text-foreground mb-2">
            {isPt ? "Política de Privacidade" : "Privacy Policy"}
          </h1>
          <p className="text-muted-foreground mb-8">
            {isPt ? "Última atualização: Janeiro 2025" : "Last updated: January 2025"}
          </p>

          <div className="prose prose-invert max-w-none space-y-8">
            <section>
              <h2 className="text-2xl font-semibold text-foreground mb-4">
                {isPt ? "1. Informações que Coletamos" : "1. Information We Collect"}
              </h2>
              <p className="text-muted-foreground">
                {isPt
                  ? "Coletamos informações que você nos fornece diretamente, como seu endereço de e-mail e nome de usuário quando você cria uma conta. Também coletamos informações sobre suas atividades na plataforma, incluindo previsões realizadas e resultados."
                  : "We collect information you provide directly to us, such as your email address and username when you create an account. We also collect information about your activities on the platform, including predictions placed and outcomes."}
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-foreground mb-4">
                {isPt ? "2. Como Usamos suas Informações" : "2. How We Use Your Information"}
              </h2>
              <p className="text-muted-foreground mb-4">
                {isPt ? "Usamos as informações coletadas para:" : "We use the information we collect to:"}
              </p>
              <ul className="list-disc list-inside text-muted-foreground space-y-2">
                <li>{isPt ? "Fornecer e manter nossos serviços" : "Provide and maintain our services"}</li>
                <li>{isPt ? "Processar suas previsões e transações" : "Process your predictions and transactions"}</li>
                <li>{isPt ? "Enviar notificações sobre eventos e resultados" : "Send notifications about events and results"}</li>
                <li>{isPt ? "Melhorar e personalizar sua experiência" : "Improve and personalize your experience"}</li>
                <li>{isPt ? "Proteger contra fraudes e abusos" : "Protect against fraud and abuse"}</li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-foreground mb-4">
                {isPt ? "3. Compartilhamento de Informações" : "3. Information Sharing"}
              </h2>
              <p className="text-muted-foreground">
                {isPt
                  ? "Não vendemos suas informações pessoais. Podemos compartilhar informações agregadas e anônimas para fins de análise. Seu nome de usuário e estatísticas de previsões são visíveis publicamente no ranking."
                  : "We do not sell your personal information. We may share aggregated and anonymous information for analytics purposes. Your username and prediction statistics are publicly visible on the leaderboard."}
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-foreground mb-4">
                {isPt ? "4. Segurança de Dados" : "4. Data Security"}
              </h2>
              <p className="text-muted-foreground">
                {isPt
                  ? "Implementamos medidas de segurança técnicas e organizacionais para proteger suas informações contra acesso não autorizado, alteração, divulgação ou destruição."
                  : "We implement technical and organizational security measures to protect your information against unauthorized access, alteration, disclosure, or destruction."}
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-foreground mb-4">
                {isPt ? "5. Seus Direitos" : "5. Your Rights"}
              </h2>
              <p className="text-muted-foreground">
                {isPt
                  ? "Você tem o direito de acessar, corrigir ou excluir suas informações pessoais. Para exercer esses direitos, entre em contato conosco através do e-mail de suporte."
                  : "You have the right to access, correct, or delete your personal information. To exercise these rights, please contact us through our support email."}
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-foreground mb-4">
                {isPt ? "6. Cookies" : "6. Cookies"}
              </h2>
              <p className="text-muted-foreground">
                {isPt
                  ? "Usamos cookies essenciais para manter sua sessão ativa e preferências. Não usamos cookies de rastreamento de terceiros."
                  : "We use essential cookies to keep your session active and preferences. We do not use third-party tracking cookies."}
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-foreground mb-4">
                {isPt ? "7. Contato" : "7. Contact"}
              </h2>
              <p className="text-muted-foreground">
                {isPt
                  ? "Se você tiver dúvidas sobre esta política de privacidade, entre em contato conosco pelo e-mail:"
                  : "If you have questions about this privacy policy, please contact us at:"}
              </p>
              <a 
                href="mailto:support@duvdex.com" 
                className="text-primary hover:underline mt-2 inline-block"
              >
                support@duvdex.com
              </a>
            </section>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default Privacy;